// features/booking/confirmBookingSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SaveComfirmBooking } from '../../../Services/BON-Frontend/Service';

export const confirmBookingThunk = createAsyncThunk(
  'booking/confirmBooking',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await SaveComfirmBooking(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const confirmBookingSlice = createSlice({
  name: 'confirmBooking',
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmBookingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(confirmBookingThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(confirmBookingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default confirmBookingSlice.reducer;